import React, { useState } from "react";
import { compose } from 'redux';
import { connect } from "react-redux";
import { isEmpty, pathOr } from 'ramda';
import { withRouter, Link } from "react-router-dom";
import { css } from 'emotion';
import { history } from "../../react-app";
import FlightResume from "./FlightResume";
import MyAccountMenu from "./MyAccountMenu";
import CancellationButton from './cancellation/CancellationButton';
import { Button } from "@maxmilhas/hangar-components-atomic/public";
import {
	$,
	checkoutCredentials,
	concatImageS3,
	redirectAfterLogout,
	redirectToLogin
} from "../../shared/utils";
import {
	getUserOrders,
	calcOrderCancelation,
	pingUser,
	logoutUser,
	getCancellationRules,
	getRebookingTrips,
	getCovidLimitDateByAirline
} from "../../shared/requests-api";
import { setOrders, setOrderToCancel, setOrderToDetail, setOrdersToRebooking } from "../../actions/index";
import CancellationModal from "./cancellation/CancellationModal";
import DetailsButton from "./details/DetailsButton";
import FinanceLink from "./FinanceLink";
import HotelLink from "./hotel/hotelLink";
import * as cs from './styles';
import HotelsEmerging from "../Hotels/HotelsEmerging";
import HotelsWidget from "../Hotels/HotelsWidget";

const customCancelationButtonStyle = {
	padding: '7px',
	fontSize: '14px',
	color: '#1abc9c',
	fontWeight: '600',
	background: 'none',
	border: '1px solid #d8dcde',
	borderRadius: '4px',
	boxShadow: 'none'
}

const customLinkStyle = `
	text-decoration: none !important
`

const statusTextAndClass = status => {
	let message, className;

	switch (status) {
		case "APROVADO":
			message = "Aguardando emissão";
			className = "approved";
			break;

		case "AGUARDANDO":
			message = "Pagamento em análise";
			className = "pending";
			break;

		case "CANCELADO":
			message = "Cancelado";
			className = "cancelled";
			break;

		case "CANCELANDO":
			message = "Cancelamento já solicitado";
			className = "pending";
			break;

		case "CHANGE_BY_CIA":
			message = "Alterado pela cia";
			className = "pending";
			break;

		default:
			message = "Status não definido";
			className = "";
	}

	return {
		statusText: message,
		className: className
	};
};

const Loader = () => (
	<article className="new-card">
		<div className="new-card__content">
			<div className="loader-container">
				<i className="loader loader-fetching center-block" />
			</div>
		</div>
	</article>
);

const FlightSituation = ({ trip }) => {
	const { eticket, status } = trip.order;
	if (eticket && status === "APROVADO") {
		return (
			<span className="highlight-strong">
				Localizador <strong>{eticket}</strong>
			</span>
		);
	}

	const {statusText, className} = statusTextAndClass(status);	
	return (
		<span className={`status status_${className}`}>
			{statusText}
		</span>
	);
};

const TripCard = ({
	trip,
	hasRebookingCredit,
	onShowCancellation: handleShowCancellation,
	onShowDetails: handleShowDetails
}) => {
	const [showHotelWidget, setShowHotelWidget] = useState(false);
	const { eticket, status } = trip.order;

	return (
		<article className="new-card">
			<div className="new-card__content">
				<div className="row">
					<div className="col-xs-16">
						<div className="order-status">
							<span className="highlight-strong">
								
								Compra <strong>{trip.order.code}</strong>
							</span>
							<FlightSituation trip={trip} />
							<div className="cancelation-button-and-finance-link">
								{/* <CancellationButton										
									outline={1}
									callback={handleShowCancellation}
									trip={trip}
									data-action="my-trips-cancellation-button"		
									style={customCancelationButtonStyle}								
								/> */}
								<FinanceLink orderCode={trip.order.code} disableInvoiceLink={trip.order.status === 'CANCELADO'} />
							</div>
						</div>
						<hr />
						<div className="my-trips-light-flight-wrapper">
							<div className="col-md-8">
								<FlightResume
									flights={trip.flights}
									passengers={trip.passengers}
								/>
							</div>
							<div className="col-md-5 col-md-offset-3 col-lg-4 col-lg-offset-4">
								<div className="order-actions">
									<DetailsButton
										onShowDetails={handleShowDetails}
										trip={trip}
									/>
									{!hasRebookingCredit && (
										<>
											<CancellationButton
												text='Cancelar'
												callback={handleShowCancellation}
												trip={trip}
												data-action="my-trips-cancellation-button"
												style={customCancelationButtonStyle}
											/>

											<CancellationButton
												text='Remarcar'
												callback={handleShowCancellation}
												trip={trip}
												data-action="my-trips-cancellation-button"
												style={customCancelationButtonStyle}
											/>
										</>
									)}

									{hasRebookingCredit && (
										<Link
											to={`/cliente/minhas-viagens-light/remarcacao?id=${trip.order.code}`}
											className={css`${customLinkStyle}`}
										>
											<Button
												size="small"
												outline
												style={customCancelationButtonStyle}
											>
												Usar crédito
											</Button>
										</Link>
									)}
								</div>

								{
									false && !window.headerHotelLink && (status === "APROVADO" || status === "AGUARDANDO") && (
										<Button
											size="small"
											outline
											style={customCancelationButtonStyle}
											onClick={() => setShowHotelWidget(!showHotelWidget)}
										>
											Reservar Hotel
										</Button>
									)
								}

								{
									window.headerHotelLink && (status === "APROVADO" || status === "AGUARDANDO") && (
										<div className="my-trips-hotel-link-wrapper">
											<HotelLink trip={trip} flagValidatorName="FLAG_HAS_BEEN_SEEN_TRIP" dataAction="hotel-link-my-trips" />
										</div>
									)
								}
							</div>
						</div>
					</div>
				</div>
				{
					showHotelWidget && !window.headerHotelLink && (status === "APROVADO" || status === "AGUARDANDO") && (
						<div className="row">
							<div className="col-xs-16">
								<HotelsWidget trip={trip} />
							</div>
						</div>
					)
				}
			</div>
		</article>
	);
}

const TripsNotFound = ({ myFlightsIMG }) => (
	<article className="new-card">
		<div className="new-card__content start-page">
			<p className="lead">Você ainda não fez nenhuma viagem com a gente :(</p>
			<p>Está esperando o que para comprar sua passagem e voar com economia?</p>
			<img src={myFlightsIMG} alt="" className="img-responsive" />
			<a href="/" title="Encontre sua passagem" className="btn btn-success">
				Encontre sua passagem
			</a>
		</div>
	</article>
);

class MyTripsLight extends React.Component {

	constructor() {
		super();
		this.state = {
			token: null,
			cancellationModalOpen: false,
			cancellationModalScenario: null,
			fetchingOrders: true,
			calculatingCancel: false,
			rebookingTrips: [],
			hasRebookingTrips: false,
			useDynamicCancellation: true
		};
		this.handleCalculateCancellation = this.handleCalculateCancellation.bind(this);
	}

	componentWillMount() {
		const getInitialStates = async () => {
			try {
				const token = await this.isAuthenticated();
				const userOrdersResponse = await getUserOrders(token);
				this.props.setUserOrders(userOrdersResponse.data);
	
				const covidJson = await getCovidLimitDateByAirline();
				let rebookingTrips = { data: [] };

				if (pathOr(true, ['data', 'configuration', 'useDynamicRebooking'], covidJson)) {
					rebookingTrips = await getRebookingTrips(token);
	
					if (rebookingTrips.data.length > 0) {
						this.props.setOrdersToRebooking(rebookingTrips.data);
					}
				}
	
				this.setState((prevState) => ({
					...prevState,
					rebookingTrips: rebookingTrips.data,
					hasRebookingTrips: rebookingTrips.data.length > 0,
					fetchingOrders: false
				}));
			} catch (error) {
				redirectToLogin(window);
				throw new Error(`${error.request.statusText} - ${error.message}`);
			}
		};

		getInitialStates();
	}

	componentWillUnmount() {
		this.setState((prevState) => ({
			...prevState,
			calculatingCancel: false
		}));
	}

	async isAuthenticated() {
		const token = checkoutCredentials().au;
		
		if(isEmpty(token)) {
			redirectToLogin(window);
			throw new Error('Token not found');
		}

		//Checa se o usuário está logado e redireciona ou busca suas compras
		const { data: { success: isAuthenticated }} = await pingUser(token);

		if(!isAuthenticated)  {
			await logoutUser();
			throw new Error('User is not logged.');
		}

		this.setState({ token });
		return token;
	}

	/** Triggers do modal de cancelamento na tela **/
	openCancellationModal(scenario) {
		$("body")
			.classList
			.add("body-lock");

		const { cancellation: { orders }} = this.props;
		const getOrderById = (orderCode, trip) => trip.order.code == orderCode;

		if (scenario.purchase) {
			scenario.order = orders.filter(getOrderById.bind(this, scenario.purchase))
			if (scenario.order.length == 1) {
				scenario.order = scenario.order[0];
			}
		} else if(scenario.type == "ExistingCancellationRequestException"){		
			var ticketId = scenario.message.search("ticketId");
			var transactionId = scenario.message.search("transactionId");

			scenario.ticketId = scenario.message.slice(ticketId, transactionId).replace(/\D/g,'');
			scenario.transactionId = scenario.message.slice(transactionId).replace(/\D/g,'');

			scenario.order = orders.filter(getOrderById.bind(this, scenario.transactionId));
			if (scenario.order.length == 1) {
				scenario.order = scenario.order[0];
			}
		}

		this.setState({
			cancellationModalOpen: true,
			cancellationModalScenario: scenario
		});
	}

	closeCancellationModal() {
		$("body")
			.classList
			.remove("body-lock");
		this.setState({
			cancellationModalOpen: false,
			cancellationModalScenario: null
		});
	}

	async handleCalculateCancellation(orderCode) {
		this.setState({ calculatingCancel: true });
		window.scrollTo(0, 0);

		try {
			const orderResponse = await calcOrderCancelation(checkoutCredentials().au, orderCode);
			const cancellationProtocolRules = await getCancellationRules(checkoutCredentials().au);
			this.props.setOrderToCancel({ ...orderResponse.data, cancellationProtocolRules: cancellationProtocolRules.data });
			history.push(`/cliente/minhas-viagens-light/cancelamento?ido=${orderCode}`);
		} catch (err) {
			if (err.response.status === 400) {
				this.setState({
					calculatingCancel: false
				});
				this.openCancellationModal(err.response.data);
			} else if (err.response.data.type == "ExistingCancellationRequestException"){
				this.setState({
					calculatingCancel: false
				});
				this.openCancellationModal(err.response.data);
			} else {
				this.setState({
					calculatingCancel: false
				});
			}
		}
	}

	handleDetailsRedirect(trip) {
		this.props.setOrderToDetail(trip);
		history.push(`/cliente/minhas-viagens-light/detalhes?ido=${trip.order.code}`);		
	}

	/**
	 * O atributo orders dentro do objeto cancellation deve ser renomeado no back end, pois em todo o front end esse objeto é tratado
	 * como trips e não orders.
	 */
	render() {
		const { 
			fetchingOrders,
			calculatingCancel,
			cancellationModalOpen,
			cancellationModalScenario,
			hasRebookingTrips,
			rebookingTrips
		} = this.state;
		const {cancellation: { orders: trips }} = this.props;
		const showLoading = fetchingOrders || calculatingCancel;

		return (
			<div className={`${css`${cs.myTrips}`} tripspage container`}>
				<div className="row">
					<aside className="col-xs-16 col-md-4">
						<MyAccountMenu />
					</aside>

					<section className="col-xs-16 col-md-12">
						{showLoading && (
							<Loader />
						)}

						{(!showLoading && hasRebookingTrips) && (
							<article className="new-card">
								<header className="new-card__header no-margin-bottom">
									<div className="rebooking-card">
										<div className="rebooking-card--icon">
											<i className="icon-max-finance-coupon" />
										</div>
										<div className="rebooking-card--heading">
											<h3>
												Você tem crédito para usar em uma nova viagem
											</h3>
											<Link to='/cliente/minhas-viagens-light/remarcacao'>Clique aqui e veja suas viagens convertidas em crédito</Link>
										</div>
									</div>
								</header>
							</article>
						)}

						{!showLoading && <h2 className="main-title">Minhas Viagens</h2>}

						{!showLoading && Array.isArray(trips) && trips.map((trip, index) => (
							<TripCard
								key={index}
								trip={trip}
								hasRebookingCredit={trip.contextualRebooking}
								onShowCancellation={this.handleCalculateCancellation}
								onShowDetails={this.handleDetailsRedirect.bind(this, trip)}
							/>
						))}

						{!showLoading && (!Array.isArray(trips) || trips.length <= 0) && (
							<TripsNotFound myFlightsIMG={concatImageS3("account/empty-flights.svg")} />
						)}
					</section>
				</div>
				<div className={`cancellation-modal tingle-modal ${ cancellationModalOpen ? "tingle-modal--visible" : ""}`}>
					<CancellationModal
						open={cancellationModalOpen}
						scenario={cancellationModalScenario}
						closeModal={this.closeCancellationModal.bind(this)}
						btnAction={this.closeCancellationModal.bind(this)}
					/>
				</div>
				{/* { !showLoading && !window.headerHotelLink && <HotelsEmerging />} */}
			</div>
		);
	}
}

const mapStateToProps = state => ({
	cancellation: state.cancellation
});

const mapDispatchToProps = dispatch => ({
	setUserOrders: orders => dispatch(setOrders(orders)),
	setOrderToCancel: orderObj => dispatch(setOrderToCancel(orderObj)),
	setOrderToDetail: order => dispatch(setOrderToDetail(order)),
	setOrdersToRebooking: orders => dispatch(setOrdersToRebooking(orders))
});

export default compose(
	withRouter,
	connect(mapStateToProps, mapDispatchToProps)
)(MyTripsLight);
